module.exports = __webpack_public_path__ + "static/media/technician.feaaa97e.svg";